import {ValidationComposite} from "../../composites";
import {ValidationBuilder as Builder} from '../../builders'

export const makeSignUpValidation = (): ValidationComposite => ValidationComposite.build([
    ...Builder.field('nickName').required().build(),
    ...Builder.field('email').required().email().build(),
    ...Builder.field('password').required().password().build(),
    ...Builder.field('passwordConfirm').required().sameAs('password').build()
])
